import 'css-chunksrc/client/scenes/assignToTask/projectSelection/zones/styles.scss';export default {
  "header": "_header_xfcnv_1",
  "title": "_title_xfcnv_10",
  "loader": "_loader_xfcnv_17"
};